import { useState } from "react";
import Cookies from "js-cookie";
import { showError } from "../../../../utils/toast.ts";
import { getApi } from "../../../../utils/api.ts";
import { API_DOWNLOAD_TIMESHEET_REPORT } from "../../../../../config/Endpoints.js";

interface UseDownloadTimesheetReportReturn {
    download: (from: string, to: string) => Promise<void>;
    isDownloading: boolean;
    error: string | null;
}

export function useDownloadTimesheetReport(): UseDownloadTimesheetReportReturn {
    const [isDownloading, setIsDownloading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const download = async (from: string, to: string): Promise<void> => {
        setIsDownloading(true);
        setError(null);

        try {
            const accessToken = Cookies.get("accessToken") ?? "";
            const userData = localStorage.getItem("userData");
            const employeeId: string = userData
                ? JSON.parse(userData).id
                : "";

            const url = `${API_DOWNLOAD_TIMESHEET_REPORT}?employeeId=${employeeId}&from=${from}&to=${to}`;

            const { data } = await getApi<Blob>(url, accessToken, "blob");

            const objectUrl = URL.createObjectURL(data);
            const anchor = document.createElement("a");
            anchor.href = objectUrl;
            anchor.download = `timesheet-report_${from}_${to}.pdf`;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(objectUrl);
        } catch (err) {
            const message =
                err instanceof Error ? err.message : "Failed to download report.";
            setError(message);
            showError(message);
        } finally {
            setIsDownloading(false);
        }
    };

    return { download, isDownloading, error };
}